
<div class="container">
  <div>
    <slot></slot>
  </div>
</div>

<style>
.container > div{
  flex: 0 1 auto;
	text-align: center;
}
</style>